import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const StatBoxStyled = styled(Box).attrs({
  py: { sm: '300' },
  px: { sm: '400' },
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
})`
  width: 48%;
  position: relative;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.grey[300]};
    border-radius: ${theme.spacings[200]};
  `};
`;

export const PopperContainerStyled = styled(Box).attrs({ alignItems: { sm: 'baseline' } })`
  left: 0;
  z-index: 2;
  width: 100%;
  position: absolute;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14);
  ${({ theme }) => css`
    border-radius: ${theme.spacings[200]};
    top: calc(${theme.spacings[600]} + ${theme.spacings[600]});
    background: ${theme.colors.white};
  `}
`;
